import palette from '../palette';
import { fade } from '@material-ui/core/styles';

export default {
  root: {
    backgroundColor: fade(palette.neutrals[7], 0.8),
  },
};
